// ============================================
// Footer Actions Component
// Design System v2.0 - Refined buttons
// ============================================

import { m } from 'framer-motion';
import { EXTERNAL_LINKS } from '@/constants';

interface FooterActionsProps {
  onLearningInfoClick: () => void;
  onFeedbackClick: () => void;
}

const ANIMATION_PROPS = {
  whileHover: { scale: 1.02 },
  whileTap: { scale: 0.98 }
};

export function FooterActions({
  onLearningInfoClick,
  onFeedbackClick
}: FooterActionsProps) {
  const openDonate = () => {
    window.open(EXTERNAL_LINKS.paypalDonate, '_blank', 'noopener,noreferrer');
  };

  return (
    <footer className="mt-8 pt-6 border-t border-slate-200">
      <div className="flex flex-wrap justify-center gap-3">
        <m.button
          type="button"
          onClick={onLearningInfoClick}
          className="btn-secondary px-4 py-2.5 text-sm font-semibold
                     hover:border-primary-400 hover:text-primary-600"
          {...ANIMATION_PROPS}
        >
          <span aria-hidden="true" className="mr-1.5 text-primary-500">?</span>
          How it Works
        </m.button>

        <m.button
          type="button"
          onClick={onFeedbackClick}
          className="btn-secondary px-4 py-2.5 text-sm font-semibold
                     hover:border-primary-400 hover:text-primary-600"
          {...ANIMATION_PROPS}
        >
          Feedback
        </m.button>

        <m.button
          type="button"
          onClick={openDonate}
          className="px-4 py-2.5 text-sm font-semibold rounded-lg
                     bg-rose-50 text-rose-600 border border-rose-200
                     hover:bg-rose-100 hover:border-rose-300
                     transition-colors"
          {...ANIMATION_PROPS}
        >
          <span aria-hidden="true" className="mr-1">&hearts;</span>
          Donate
        </m.button>
      </div>
    </footer>
  );
}
